const TaxReceiptUnavailableReasonEnum = Object.freeze({
    NOT_ENABLED: 'NOT_ENABLED',
    OFFLINE_AFTER_SALE: 'OFFLINE_AFTER_SALE',
    OFFLINE_DURING_SALE: 'OFFLINE_DURING_SALE',
});

module.exports = TaxReceiptUnavailableReasonEnum;
